import { Send } from '../Send/Send'

export const SendPage = () => <Send />
